import { Table, Thead, Tbody, Tr, TableContainer, Skeleton, Td, Card, Box } from '@chakra-ui/react';
import TableElement from './TableElement';
import TableHeader from './TableHeader';
import NoInvoiceDisclaimer from './NoInvoiceDisclaimer';
import SubscriptionOfferCard from './SubscriptionOfferCard';
import { useInvoices } from '../hooks/useInvoices';
import { useContext } from 'react';
import { INVOICE_TABS, InvoiceTab } from '../constants/enums';
import { useBreakpointsContext } from '../hooks/useBreakpointsContext';
import MerchantContext from '../contexts/MerchantContext';

function isNonNullish<T>(value: T | undefined | null | void): value is T {
  return value !== undefined && value !== null;
}

type Props = { tab: InvoiceTab };

const TableStructure = ({ tab }: Props): JSX.Element => {
  const { isXLargeScreen } = useBreakpointsContext();

  const { merchant } = useContext(MerchantContext);

  const { readyInvoices, paidInvoices, isLoading } = useInvoices();

  const invoices = tab === INVOICE_TABS.PENDING ? readyInvoices : paidInvoices;

  const showDetails = invoices?.some((ele) => ele.details);
  const showMinimumAmount = invoices?.some((ele) => ele.minimumAmount);

  const columns = [
    'Concepto',
    'N.Referencia',
    tab === INVOICE_TABS.PAID ? 'Fecha de Pago' : 'Vencimiento',
    tab === INVOICE_TABS.PAID ? 'Valor' : 'Valor',
    'Estado',
    showMinimumAmount ? 'Pago Mínimo' : null,
    merchant?.erp === 'mobilia' ? 'Cod. de Barras' : '',
    showDetails ? '' : null,
  ].filter(isNonNullish);

  return (
    <Box display="flex" flexDirection="column" width="100%">
      <Card width="100%" variant={isXLargeScreen ? 'outline' : 'unstyled'}>
        <Skeleton isLoaded={!isLoading}>
          <TableContainer overflowX={{ base: 'visible', '2xl': 'auto' }}>
            <Table variant="unstyled">
              {isXLargeScreen && (
                <Thead>
                  <Tr>
                    {columns.map((ele, index) => (
                      <TableHeader columnName={ele} key={index} />
                    ))}
                  </Tr>
                </Thead>
              )}
              <Tbody>
                {!invoices || invoices.length < 1 ? (
                  <Tr>
                    <Td colSpan={columns.length}>
                      <NoInvoiceDisclaimer tab={tab} />
                    </Td>
                  </Tr>
                ) : (
                  invoices.map((ele, index) => (
                    <TableElement
                      invoice={ele}
                      key={index}
                      showDetails={showDetails}
                      showMinimumAmount={showMinimumAmount}
                      tableIndex={index}
                    />
                  ))
                )}
              </Tbody>
            </Table>
          </TableContainer>
        </Skeleton>
      </Card>
      {tab === INVOICE_TABS.PENDING && <SubscriptionOfferCard />}
    </Box>
  );
};

export default TableStructure;
